type CallbackFunction = (...args: any[]) => void;

export function debounce(callback: CallbackFunction, wait: number, immediate: boolean = false): (...args: any[]) => void {
  let timeout: NodeJS.Timeout | null = null;

  return function(this: any, ...args: any[]): void {
    const callNow = immediate && !timeout;
    const next = (): void => callback.apply(this, args);

    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(next, wait);

    if (callNow) {
      next();
    }
  };
}

export function throttle(callback: CallbackFunction, wait: number, immediate: boolean = false): (...args: any[]) => void {
  let timeout: NodeJS.Timeout | null = null;
  let initialCall = true;

  return function(this: any, ...args: any[]): void {
    const callNow = immediate && initialCall;
    const next = (): void => {
      callback.apply(this, args);
      timeout = null;
    };

    if (callNow) {
      initialCall = false;
      next();
    }

    if (!timeout) {
      timeout = setTimeout(next, wait);
    }
  };
}
